/**
 * Allowed HTTP methods: GET, POST, PUT, DELETE
 */
export enum HttpMethod {
    get = 'GET',
    post = 'POST',
    put = 'PUT',
    patch = 'PATCH',
    delete = 'DELETE',
}
